import WrapperService from '@/modules/core/services/wrapper-service';
import {createPageableParams} from '@/modules/core/services/table-utils';

const settingsServiceName = "Scheduler-Service: ";
const SCHEDULER_API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/display/schedule/settings';

export default class SchedulerService {

    static async readAllSchedulersPaginated(page, size, search, sort, sortAsc, successF, errorF) {
        let params = createPageableParams(page, size, search, sort, sortAsc, successF, errorF, ['name'], ['name']);
        await WrapperService.get(SCHEDULER_API_URL + '/page?' + params, null, settingsServiceName, successF, errorF);
    }

    static async saveScheduler(scheduler, successF, errorF) {
        if (typeof scheduler.id === 'undefined' || scheduler.id === null) {
            await WrapperService.post(SCHEDULER_API_URL, scheduler, settingsServiceName, successF, errorF);
        } else {
            await WrapperService.put(SCHEDULER_API_URL + '/' + scheduler.id, scheduler, settingsServiceName, successF, errorF);
        }
    }

    static async deleteScheduler(id, successF, errorF) {
        await WrapperService.delete(SCHEDULER_API_URL + '/' + id, null, settingsServiceName, successF, errorF);
    }
}